$.fn.dxCtrlSaisieCleMyPos = function custom_dxCtrlSaisieCleMyPos(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsaisieclemypos dx-ctrl");
        this.createInstance(new cdxCtrlSaisieCleMyPos(this, option));
    }
    return this;
}

window.cdxCtrlSaisieCleMyPos = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var txt = ""
        if (option.societe.has_cle_mypos == "0") { txt = "Saisir les clés myPOS pour CB internet" }
        else { txt = "Modifier les clés myPOS pour reglement CB" }
        $("<br/>").appendTo(container)
        var $DivBtCleMyPos = $("<div style='width:100%'/>").appendTo(container).dxCtrlButton({
            text: txt,
            width: "100%",
            txtTooltip: ((option.societe.has_cle_mypos == "0") ? "Saisir" : "Modifier") + " les clés myPOS qui vous permettrons d'activer les règlements CB sur l'application pour vos clients",
            onClick: function (e) {
                if (option.bddCtrl.isDemo) {
                    mNotify("Vous êtes dans un environnement de démo.<br/>Vous ne pouvez pas modifier les clés myPOS.", "warning", 6000)
                } else {
                    var packConfigContenu = null;
                    var nomFichierCharge = null;
                    var $ZoneManuelle = null;
                    var dxCtrlTextBoxSid = null;
                    var dxCtrlTextBoxWalletNumber = null;
                    var dxCtrlTextBoxKeyIndex = null;
                    var dxCtrlTextBoxClePrivee = null;
                    var pop = $("<div/>").appendTo("body").dxPopup({
                        shading: true,
                        height: "auto",
                        width: 650,
                        title: "Saisie des clés API myPOS",
                        contentTemplate: function (contentElement) {
                            $("<div style='margin-bottom:10px;'>Déposez le fichier <b>Pack de configuration</b> téléchargé depuis votre compte myPOS (menu <i>Boutique &gt; Intégration &gt; Générer le pack de configuration</i>). C'est la méthode recommandée : un seul fichier à fournir.</div>").appendTo(contentElement)

                            var $DivFichier = $("<div style='border:1px dashed #999;border-radius:4px;padding:15px;text-align:center;'/>").appendTo(contentElement)
                            var $InputFichier = $("<input type='file' accept='.txt' />").appendTo($DivFichier)
                            var $LabelFichier = $("<div style='margin-top:8px;color:" + theme.toastError + ";'>Aucun fichier chargé pour le moment.</div>").appendTo($DivFichier)

                            $InputFichier.on("change", function (e) {
                                var fichier = e.target.files && e.target.files[0]
                                if (!fichier) return
                                var reader = new FileReader()
                                reader.onload = function (evt) {
                                    packConfigContenu = (evt.target.result || "").toString().trim()
                                    nomFichierCharge = fichier.name
                                    $LabelFichier.text("Fichier chargé : " + nomFichierCharge)
                                    $LabelFichier.css("color", theme.toastSuccess)
                                }
                                reader.onerror = function () {
                                    packConfigContenu = null
                                    nomFichierCharge = null
                                    $LabelFichier.text("Impossible de lire ce fichier, merci de réessayer.")
                                    $LabelFichier.css("color", theme.toastError)
                                }
                                reader.readAsText(fichier)
                            })

                            $("<br/>").appendTo(contentElement)
                            var $LienAvance = $("<div style='cursor:pointer;text-decoration:underline;color:#666;margin-top:5px;'>Saisie manuelle avancée (sans le pack de configuration)</div>").appendTo(contentElement)
                            $ZoneManuelle = $("<div style='display:none;margin-top:10px;'/>").appendTo(contentElement)

                            $LienAvance.on("click", function () {
                                $ZoneManuelle.toggle()
                            })

                            $('<input type="password" style="display: none"/>').appendTo($ZoneManuelle)
                            dxCtrlTextBoxSid = $("<div/>").appendTo($ZoneManuelle).dxCtrlTextBox({
                                labelMode: 'floating',
                                label: "SID (identifiant de la boutique myPOS)",
                                value: ""
                            }).dxCtrlTextBox("instance");
                            $("<br/>").appendTo($ZoneManuelle)
                            dxCtrlTextBoxWalletNumber = $("<div/>").appendTo($ZoneManuelle).dxCtrlTextBox({
                                labelMode: 'floating',
                                label: "Numéro de wallet (Client Number)",
                                value: ""
                            }).dxCtrlTextBox("instance");
                            $("<br/>").appendTo($ZoneManuelle)
                            dxCtrlTextBoxKeyIndex = $("<div/>").appendTo($ZoneManuelle).dxCtrlTextBox({
                                labelMode: 'floating',
                                label: "KeyIndex",
                                value: ""
                            }).dxCtrlTextBox("instance");
                            $("<br/>").appendTo($ZoneManuelle)
                            dxCtrlTextBoxClePrivee = $("<div/>").appendTo($ZoneManuelle).dxCtrlTextBox({
                                labelMode: 'floating',
                                mode: 'password',
                                label: "Clé privée myPOS (PEM complet, avec les lignes BEGIN/END)",
                                value: "",
                                onContentReady: function (e) {
                                    e.component.element().find("input").attr("name", "kjkjkljlkjlmklmlk")
                                }
                            }).dxCtrlTextBox("instance");

                            $("<br/>").appendTo(contentElement)

                            var $Table = $("<table/>").appendTo(contentElement)
                            var $Tr = $("<tr/>").appendTo($Table);
                            var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                            if (option.societe.has_cle_mypos == "1") {
                                $("<div/>").appendTo($Td).dxCtrlButton({
                                    text: "Supprimer les clés",
                                    txtTooltip: "Supprimer les clés API saisies",
                                    onClick: function (e) {
                                        var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                                        jauge.mShow();
                                        option.bddCtrl.mAjaxCall({
                                            command: "deleteapikeymypos",
                                            id_societe: option.societe.id_societe
                                        }, function (data) {
                                            option.societe.has_cle_mypos = "0"
                                            pop.hide()
                                        })
                                    }
                                })
                            }
                            var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                            mAddButtonOkAnnuler($Td, function () {
                                //ok
                                //sauvegarde des clés api
                                var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                                jauge.mShow();
                                var params = {
                                    command: "savesaisieapikeymypos",
                                    id_societe: option.societe.id_societe
                                }
                                if (packConfigContenu) {
                                    params.pack_config_mypos = packConfigContenu
                                } else {
                                    params.sid_mypos = dxCtrlTextBoxSid.option("value")
                                    params.wallet_number_mypos = dxCtrlTextBoxWalletNumber.option("value")
                                    params.key_index_mypos = dxCtrlTextBoxKeyIndex.option("value")
                                    params.cle_privee_mypos = dxCtrlTextBoxClePrivee.option("value")
                                }
                                option.bddCtrl.mAjaxCall(params, function (data) {
                                    jauge.mHide();
                                    if (data.ok == "0") {
                                        mNotify("Votre saisie est erronée" + (data.text_erreur ? "<br/>" + data.text_erreur : ""), "error", 6000)
                                    } else {
                                        mNotify("Votre saisie est correcte et votre configuration MYPOS pour vos paiement CB internet est active", "success", 6000)
                                        option.societe.has_cle_mypos = "1"
                                        pop.hide()
                                    }
                                })
                            }, function () {
                                pop.hide()
                            });
                        },
                        onHiding: function (e) {
                        },
                        onHidden: function (e) {
                            var txt = ""
                            if (option.societe.has_cle_mypos == "0") { txt = "Saisir les clés myPOS pour reglement CB" }
                            else { txt = "Modifier les clés myPOS pour reglement CB" }
                            $DivBtCleMyPos.option("text", txt)
                            $DivBtCleMyPos.option("txtTooltip", ((option.societe.has_cle_mypos == "0") ? "Saisir" : "Modifier") + " les clés myPOS qui vous permettrons d'activer les règlements CB sur l'application pour vos clients")
                            $DivMessageCleApiCb.text(((option.societe.has_cle_mypos == "0") ? "Le paiement CB par internet n'est pas actif pour cette société." : "Le paiement CB par internet est actif pour cette société"))
                            $DivMessageCleApiCb.css("color", ((option.societe.has_cle_mypos == "0") ? theme.toastError : theme.toastSuccess))
                            e.component.element().remove()
                        }
                    }).dxPopup("instance")
                    pop.show()
                    if (option.societe.has_cle_mypos == "1") {
                        mNotify("Vous disposez de clé myPOS mais celle-ci ne peuvent-être affichées pour des raisons de sécurité. Déposez un nouveau pack de configuration (ou ressaisissez les champs manuellement) pour les modifier sur le serveur.", "warning", 8000)
                    }
                }
            }
        }).dxCtrlButton("instance")
        var $DivMessageCleApiCb = $("<div style='color:" + ((option.societe.has_cle_mypos == "0") ? theme.toastError : theme.toastSuccess) + ";text-align:center;padding:5px;'>" + ((option.societe.has_cle_mypos == "0") ? "Le paiement CB par internet n'est pas actif pour cette société." : "Le paiement CB par internet est actif pour cette société") + "</div>").appendTo(container)
    }

    this.element = function () { return container }

    mConstruit();
}
